import * as React from 'react';
import {Interpolate, translate} from 'react-i18next';
import * as s from './Text.scss';

interface Props {
  i18nKey: string;
  parent?: string;
  className?: string;
}

export const Text: React.SFC<Props> = ({children, ...otherProps}) => {
  return (
    <Interpolate
      {...otherProps}
      lineBreak={<br />}
      lineBreakMobile={<span className={s.lineBreakMobile} />}
    />
  );
};

export const TranslatedText = translate()(Text);
